import { makeAutoObservable, runInAction } from 'mobx';

import { ProductState } from './CategoriesStore';

export type NavigationState =
  | 'default'
  | 'product'
  | 'counter'
  | 'backOnly'
  | 'backWithCart'
  | 'withBack'
  | 'cart'
  | 'editAddressLocation'
  | 'checkout'
  | 'withActions';

class BottomNavigationStore {
  state: NavigationState = 'default';
  product: ProductState | null = null;
  count: number = 1;
  isModal: boolean = false;
  filters: boolean = false;
  onAddToCart?: () => void;
  onCounterChange?: (count: number, action: 'add' | 'remove') => void;

  constructor() {
    makeAutoObservable(this);
  }

  setState(state: NavigationState) {
    this.state = state;
  }

  setFilters(opened: boolean) {
    this.filters = opened;
  }

  setProductState(state: ProductState | null) {
    runInAction(() => {
      this.product = state;
    });
  }

  reset() {
    this.state = 'default';
  }
}

export const bottomNavigationStore = new BottomNavigationStore();
